import { useEffect, useState } from "react";
import { AppListing } from "../../components/appListing";
import moment from "moment";
import {
  useGetEducationsQuery,
} from "../../redux/service/education_service";
import { IoMdEye } from "react-icons/io";
import MainPageDialog from "../../components/mainPageDialog";
import { toast } from "react-toastify";
import { getUser } from "../../userStore";
import { getBaseUrl } from "../../utils/common_lib";

export const Educations = ({ header = true }) => {
  const [educationsList, setEducationsList] = useState([]);
  const [previewData, setPreviewData] = useState(null);
  const userData = getUser()

  moment.updateLocale("fr", {
    invalidDate: "-",
  });

  const cols = [
    {
      title: "Title",
      getData: (item) =>
        item?.["education_data"]?.length > 0
          ? item?.["education_data"][0]?.title
          : "-",
      colClass: "text-wrap",
    },
    {
      title: "Created on",
      key: "dispense",
      getData: (item) => moment(item?.created).format("MM/DD/YYYY h:mm A"),
    },
    {
      title: "Description",
      getData: (item) =>
        item?.["education_data"]?.length > 0
          ? item?.["education_data"][0]?.description
          : "-",
      colClass: "text-wrap",
    },
    {
      title: "Preview",
      key: "preview",
      colClass: "col-md-1 text-center",
      getData: () => (
        <div className="flex w-[100%] items-center justify-center px-2">
          <IoMdEye />
        </div>
      ),
      onClick: (item) => setPreviewData(item),
    },
  ];

  let fileUrl = `${getBaseUrl()}/messages/read_attachment.json?uuid=${
    previewData && previewData.education_data[0]?.education_uuid
  }&token=${userData?.token}&tz=${new Date().getTimezoneOffset()}`;

  let html = `<iframe id="printDiv" width="100%" height="1100" scrolling="auto" frameborder="1" allow="autoplay" src=${fileUrl}></iframe>`;

  const { data, refetch } = useGetEducationsQuery({
    shared_to_patient_portal: 1,
  });

  useEffect(() => {
    if (data?.data && data?.data) {
      setEducationsList(data?.data);
    }
  }, [data]);

  return (
    <>
      {previewData && (
        <MainPageDialog
          title={previewData.education_data[0]?.title}
          modalSize="md"
          maxHeight={true}
          footerList={[
            {
              type: "close",
              title: "Close",
              action: () => setPreviewData(null),
            },
          ]}
          onCancelHandler={() => setPreviewData(null)}
        >
          <div dangerouslySetInnerHTML={{ __html: html }}></div>
        </MainPageDialog>
      )}
      <div className="flex border-gray-300 bg-gray-200 px-3 py-3 sm:px-4 flex-wrap items-center justify-between sm:flex-nowrap">
        <div className="">
          <h3 className="text-base font-semibold leading-6 text-gray-900">
            Educations
          </h3>
        </div>
        <div className=" flex-shrink-0">
          <button
            type="button"
            onClick={refetch}
            className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Reload
          </button>
        </div>
      </div>
      <div className="flex-auto bg-white justify-start p-3 text-start">
        <AppListing listData={educationsList || []} cols={cols} />
      </div>
    </>
  );
};
